/*
  Remote Submit Success Link

  EMITTED EVENTS
    update-success (document) Emitted when the request corresponding to the link click is successfully submitted, if event-details-type
    is set in data
      detail: {
        el:   the root element of this controller instance,
        ...detail: the passed in detail
      }
*/

import { createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {

  connect() {
    App.Helpers.addAjaxSuccessHandler(this.element, this.emitSubmitSuccessEvent.bind(this));
  }

  emitSubmitSuccessEvent() {
    document.dispatchEvent(createCustomEvent('update-success', this.element, this.detail));
  }

  //
  // GETTERS AND SETTERS
  //

  get detail() {
    return this.data.has('detail') ? JSON.parse(this.data.get('detail')) : {};
  }
};



// WEBPACK FOOTER //
// ./app/components/page_updaters/assets/javascript/page-updaters-content-update-link-controller.js